import T from '../types';

export default () => (filter) => {
  return {
    type: T.FILTER_APPLY,
    filter,
  };
};
